module.exports = __webpack_public_path__ + "static/media/flat-hammer.dff14efb.svg";